<template lang="pug">
  .subscribable-cta.xs-12
    .cta-wrap.xs-12(v-if="product.product_type_renewable")
      .price-wrap
        p.strike.color-slate.xs-f-small.lg-f-medium.max-at-tweak {{product.price | currency}}
        p.color-purple.bold.xs-f-xlarge.lg-f-xxlarge.max-at-tweak {{product.sub_price | currency}}
      p.save.xs-f-medium.lg-f-xmedium.max-at-tweak Save time &amp; money
      a.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:href="'/product/' + product.url_key") subscribe
      p.slate.text-center.xs-f-xsmall.max-at-tweak Cancel online anytime

    .xs-12
      BenefitsTable(
        v-if="product.membershipBenefits && product.oneTimeBenefits"
        :first-time-benefits="product.firstTimeMemberBenefit ? [product.firstTimeMemberBenefit] : []"
        :membership-benefits="product.membershipBenefits"
        :one-time-benefits="product.oneTimeBenefits"
      )
  
</template>

<script>
  import BenefitsTable from "./BenefitsTable";
  export default {
    name: "SubscribeWithBenefits",
    components: {
      BenefitsTable
    },

    props: {
      product: {
        type: Object,
        required: true
      }
    }
   }
</script>

<style scoped lang="stylus">
  .subscribable-cta
    .cta-wrap
      background-color #e6eef6
      padding 1em 5%

      .price-wrap
        display inline-block

      .save
        display inline-block
        vertical-align bottom
        padding-left 3.5em

      .mr-btn
        margin 1.5em auto


  @media mq-tablet
    .subscribable-cta
      .cta-wrap
        padding 1em 15%

  @media mq-desktop-md
    .subscribable-cta
      .cta-wrap
        padding 1em 28%


  @media mq-desktop-plus
    .subscribable-cta
      .cta-wrap
        padding 1em 32%

</style>